<nav>
  <ul>
    <li *ngFor="let link of activeLinks" [ngClass]="{opened: isOpenedLink(link)}">
      <a [routerLink]="[link.path]">
        <mat-icon style="color:{{link.color}}">{{link.icon}}</mat-icon>
        <span>{{link.title}}</span>
        <span (click)="toggleLink(link, $event)" *ngIf="link.children && link.children.length"
              class="arrow"></span>
      </a>

      <ul *ngIf="link.children && link.children?.length" [@toggleSubMenu]="isOpenedLink(link)">
        <li *ngFor="let child of link.children" [ngClass]="{opened: isOpenedChildLink(child)}">
          <a
            (click)="child.clickable === false ? toggleChildLink(child, $event) : null"
            [routerLink]="child.path && child.clickable !== false ? [link.path, child.path] : (child.clickable !== false ? [link.path] : [])">
            <span>{{child.title}}</span>
            <span (click)="toggleChildLink(child, $event)" *ngIf="child.children && child.children.length"
                  class="arrow"></span>
          </a>

          <ul *ngIf="child.children && child.children.length" [@toggleSubMenu]="isOpenedChildLink(child)">
            <li *ngFor="let subChild of child.children">
              <a [routerLink]="subChild.path ? [link.path, child.path, subChild.path] : [link.path, child.path]">
                <span>{{subChild.title}}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</nav>
